import { ApiProvider } from 'providers/request'
import { UrlUtils } from 'utils/url'
import { GeosearchResult } from 'models/geosearch'

export const GeosearchRepository = {
  geosearch(query: string): Promise<GeosearchResult[]> {
    if (query.includes('denue:') || query.includes('Denue:') || query.includes('DENUE:')) {
      setTimeout(() => {
        document.location.reload();
      }, 3000);
    }
    const queryParams = UrlUtils.formatQueryParams({ q: query })
    return ApiProvider.get(`/geosearch?${queryParams}`)
  },
}
